import React from 'react'
import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useAccountProfileQuery = () => {
  return useGenericRequestHandler({
    route: 'v1/i/profile',
    method: 'GET'
  })
}
